(function () {
  "use strict";

  angular
    .module('branding')
    .directive('brandPreviewControl', brandPreviewControl);

  function brandPreviewControl() {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        numOfPages: '='
      },
      templateUrl: 'pages/branding/template/previewControl.html',
      link: function (scope, element, attrs) {

        scope.selectedSlide = 1;

        scope.getNumber = function (num) {
          return new Array(num);
        };

        scope.scrollToNextPage = function (value) {
          angular.element('.jcarousel').jcarousel('scroll', value);
          scope.selectedSlide = value;
        };
      }
    };
  }

})();
